module.exports = __webpack_public_path__ + "media/images/background_graphics/publication_graphic_tablet-bf436375473ad6b62aa2948aec1d6904.svg";